import { SessionModel } from './../session/entities/sessionModel';
import { BefreiungErgebnis } from './../befreiung/shared/entities/befreiungErgebnis';
import { ActionReducer, Action } from '@ngrx/store';

import { IAppState } from './app.state';
import { PASSWORT_GEAENDERT, BEFREIUNG_GEFUNDEN, IK_REGISTRIERT, LOGIN, LOGOUT, IDLE, ERROR, ActionWithPayload, All } from './app.actions';
import { LoginData } from '../session/entities/LoginModel';
import { PasswordChangedModel } from '../account/changepassword/entities/passwordChangedModel';

const SESSION_TIMEOUT = 10;

export const initialAppState: IAppState = {
  befreiungErgebnis: {
    KvNummer: '',
    Initialen: '',
    Befreiungen: []
  },
  session: {
    loggedIn: false,
    isIdleRunning: false,
    sessionTimeout: 0,
    user: null,
    passwordNeedsChange: { PasswordNeedsChange: false, Reason: '' },
    token: null,
    pinRequired: false
  },
  error: null,
};

function befreiungGefunden(state: IAppState, befreiungErgebnis: BefreiungErgebnis): IAppState {
  return {
    ...state,
    befreiungErgebnis: befreiungErgebnis
  };
}

function passwortGeaendert(state: IAppState, pwChange: PasswordChangedModel): IAppState {
  return {
    ...state,
    session: {
      ...state.session,
      loggedIn: state.session.loggedIn,
      isIdleRunning: true,
      sessionTimeout: SESSION_TIMEOUT,
      token: pwChange.token
    }
  };
}

function ikRegistriert(state: IAppState): IAppState {
  return {
    ...state,
    session: {
      ...state.session,
      loggedIn: state.session.loggedIn,
      sessionTimeout: SESSION_TIMEOUT
    }
  };
}

function login(state: IAppState, loginData: LoginData): IAppState {
  const newState: IAppState = {
    ...initialAppState,
    session: {
      loggedIn: true,
      isIdleRunning: loginData.isIdleRunning,
      sessionTimeout: SESSION_TIMEOUT,
      user: loginData.username,
      passwordNeedsChange: loginData.passwordNeedsChange,
      token: loginData.token,
      pinRequired: loginData.pinRequired
    }
  };
  return newState;
}

function idle(state: IAppState, timeout: number): IAppState {

  return {
    ...state,
    session: {
      ...state.session,
      sessionTimeout: timeout
    }
  };
}

function logout(state: IAppState): IAppState {
  return { ...initialAppState };
}

function error(state: IAppState, error: any): IAppState {
  return {
    ...initialAppState,
    error: {
      title: error.title, message: error.message, forwardLink: error.forwardLink, forwardText: error.forwardText }
  };
}

export function appReducer(state: IAppState, action: ActionWithPayload<any>): IAppState {
  switch (action.type) {
    case BEFREIUNG_GEFUNDEN: return befreiungGefunden(state, action.payload);
    case PASSWORT_GEAENDERT: return passwortGeaendert(state, action.payload);
    case IK_REGISTRIERT: return ikRegistriert(state);
    case LOGIN: return login(state, action.payload);
    case LOGOUT: return logout(state);
    case IDLE: return idle(state, action.payload);
    case ERROR: return error(state, action.payload);
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/appState/app.reducer.ts